export default __webpack_public_path__ + "static/media/github.b9cb3d3e.svg";